.content {
	height: 100%;
	background-color: var(--ds-surface, var(--adg3-color-N0));
	box-shadow: 0 -2px var(--ds-border, var(--adg3-color-N40)); /* This box-shadow here works as border */
	box-sizing: border-box;
	overflow: hidden;
}
